import { getDistance } from 'geolib';

/** Max distance (m) to treat KML geometry as the same cerca as DB lat/lng center. */
export const CERCA_COORD_MATCH_METERS = 18;

/**
 * @param {number} lat
 * @param {number} lng
 * @param {Array<{ id_cerca, lat_centro, lng_centro, is_circular? }>} catalog
 * @returns {object|null} nearest cerca row within threshold
 */
export function findExistingCercaAt(lat, lng, catalog) {
  if (lat == null || lng == null || !Array.isArray(catalog) || catalog.length === 0) {
    return null;
  }
  const la = Number(lat);
  const ln = Number(lng);
  if (!isFinite(la) || !isFinite(ln)) {
    return null;
  }
  const target = { latitude: la, longitude: ln };
  let best = null;
  let bestD = Infinity;
  for (let i = 0; i < catalog.length; i++) {
    const c = catalog[i];
    if (c == null) continue;
    const plat = Number(c.lat_centro);
    const plng = Number(c.lng_centro);
    if (!isFinite(plat) || !isFinite(plng)) continue;
    const d = getDistance({ latitude: plat, longitude: plng }, target);
    if (d <= CERCA_COORD_MATCH_METERS && d < bestD) {
      bestD = d;
      best = c;
    }
  }
  return best;
}

/** Split once for shape-aware matching (circular vs polygon pools). */
export function partitionCercasCatalogByShape(catalog) {
  const circularOnly = [];
  const polygonOnly = [];
  if (!Array.isArray(catalog)) {
    return { circularOnly, polygonOnly };
  }
  for (let i = 0; i < catalog.length; i++) {
    const x = catalog[i];
    if (!x) continue;
    if (Number(x.is_circular) === 1) circularOnly.push(x);
    else polygonOnly.push(x);
  }
  return { circularOnly, polygonOnly };
}

/**
 * Centroid of first linear ring (GeoJSON [lng, lat][]).
 */
export function ringCentroidLngLat(ring) {
  if (!Array.isArray(ring) || ring.length < 1) {
    return null;
  }
  let n = ring.length;
  if (
    n > 2 &&
    Number(ring[0][0]) === Number(ring[n - 1][0]) &&
    Number(ring[0][1]) === Number(ring[n - 1][1])
  ) {
    n -= 1;
  }
  if (n < 1) return null;
  let sumLat = 0;
  let sumLng = 0;
  for (let i = 0; i < n; i++) {
    sumLng += Number(ring[i][0]);
    sumLat += Number(ring[i][1]);
  }
  return { lat: sumLat / n, lng: sumLng / n };
}
